import styled from "styled-components";

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    font-family: ${(props) => props.defaultFontFamily ? props.defaultFontFamily : 'inherit'};
`;

export const CarouselContainer = styled.div`
    display: flex;
    background-color: ${(props) => props.bgColor ? props.bgColor : 'white'};
    overflow: hidden;
    cursor: grab;
    scroll-behavior: smooth;
    touch-action: none;

    div:first-child {
        margin-left: 0;
    }
`;

export const ProgressBarWrapper = styled.div`
    background-color: black;
    width: 100%;
    height: 5px;
    overflow: hidden;
`;

export const ProgressBar = styled.div`
    background-color: ${(props) => (props.bgColor ? props.bgColor : "black")};
    width: ${(props) => (props.progressPercent ? props.progressPercent : 0)}%;
    max-width: 100%;
    height: 100%;
`;

export const StyledImageWrapper = styled.div`
    &&&&&&& {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        min-width: ${(props) => `calc(100% / ${props.imagesPerPage.large})`};
        margin-left: ${(props) =>
            props.marginLeft ? `${props.marginLeft}px` : 0};
        overflow: hidden;

        @media screen and (max-width: 900px) {
            min-width: ${(props) =>
                `calc(100% / ${props.imagesPerPage.medium})`};
        }

        @media screen and (max-width: 550px) {
            min-width: ${(props) =>
                `calc(100% / ${props.imagesPerPage.small})`};
        }
    }

    ${({ hasLink }) =>
        hasLink &&
        `
        &&&&&&&:hover img,
        &&&&&&&:active img {
            transform: scale(1.1);
            transition: all ease;
            transition-duration: 1s;
        }

        &&&&&&&:hover span,
        &&&&&&&:active span {
            opacity: 100;
            transition: opacity ease;
            transition-duration: 1s;
        }

        &&&&&&&:hover .ImageOverlay {
            opacity: 70%;
        }
    `}
`;

export const StyledOverlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0%;
    background-color: black;

    transition: opacity ease;
    transition-duration: 1s;
    z-index: 1;

    ${({ hasLink }) =>
        hasLink &&
        `
    // overlay
    &:hover {
        opacity: 70%;
    }
    `}
`;

export const StyledImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    user-select: none;
    transition: all ease;
    transition-duration: 1s;

    // images have small jump when scaled because scale rounds width/height...
    // need to set scale initially so it's already rounded and doesn't jump
    transform: scale(1.01);
`;

export const ImageText = styled.span`
    position: absolute;
    color: ${(props) => (false ? props.linkColor : "white")};
    font-size: 1.2rem;
    font-family: inherit;
    opacity: 0;
    margin-bottom: 20px;
    text-align: center;
    user-select: none;
    z-index: 10;
    text-decoration: ${(props) => (props.link ? "underline" : "none")};

    transition: opacity ease;
    transition-duration: 1s;
    cursor: pointer;

    &:hover {
        color: ${(props) =>
            props.linkHoverColor ? props.linkHoverColor : "royalblue"};
    }
`;

export const BulletPointContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    padding: 10px 0;
`;

export const ImageBulletPoint = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 100px;
    background-color: ${(props) => props.isActive ? props.backgroundColor : 'unset'};
    border: 1px solid ${(props) => props.backgroundColor ?? 'red'};
    margin: 0 2.5px;
    cursor: pointer;
`;